import { Search } from "lucide-react";

const InputPesquisa = (props) => {
  return (
    <div className="relative w-full max-w-md">
      <Search
        className="absolute left-4 top-1/2 -translate-y-1/2 text-gray-400"
        size={20}
      />
      <input
        className="w-full rounded-[50px] border-[1px] border-gray-400 px-4 py-2 pl-12 text-lg shadow-md shadow-blue-100 outline-none focus:border-blue-500"
        type={props.type}
        onChange={(e) => props.mudar(e)}
        value={props.value}
        placeholder={props.placeholder}
      />
    </div>
  );
};

export default InputPesquisa;
